'use client';

import { useEffect } from 'react';
import { useTranslations } from 'next-intl';
import { Link } from '@/navigation';
import ArrowLabel from '@/components/ui/ArrowLabel';

export default function NotFound() {
  const t = useTranslations('notFound');

  // Keep the 404 to a single screen: the locale layout always renders the tall
  // Footer below us, so lock page scroll while this page is mounted (restored on
  // navigate away). The Header is position:fixed, so it adds no flow height and
  // our full-viewport section is the only thing visible.
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return (
    <section className="relative flex h-[100dvh] flex-col items-center justify-center px-margin-mobile text-center lg:px-margin-desktop">
      {/* Oversized, muted numeral — tonal layering, no shadows (per design system). */}
      <p className="font-headline text-[4rem] font-bold leading-none tracking-tight text-outline-variant/50 short:text-[3.5rem] sm:text-[7rem]">
        404
      </p>
      <h1 className="mt-stack-md font-headline text-headline-lg font-bold tracking-[0.02em] text-on-surface">
        {t('title')}
      </h1>
      <p className="mt-stack-md max-w-md text-body-md text-on-surface-variant md:text-body-lg">
        {t('desc')}
      </p>

      {/* Primary pill CTA → home, with the slide-in arrow used across the site. */}
      <Link
        href="/"
        className="group mt-stack-lg inline-flex items-center justify-center rounded-full bg-on-surface px-8 py-4 font-headline text-body-md font-bold text-background transition-all duration-200 hover:opacity-90 active:scale-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background"
      >
        <ArrowLabel>{t('back')}</ArrowLabel>
      </Link>
    </section>
  );
}
